import React, { useState, useEffect, useRef } from 'react';

import SatCheckBox from '@components/common/satUI/SatCheckBox';
import SatToolTip from '@components/common/satUI/SatToolTip';
import SatInput from '@components/common/satUI/SatInput';

import { toFloatNumber, toNumber, toCurrency } from '@common/utils/index';
const UNIT = '1,000';
const KrwFixedOption = props => {
  const {
    fixedOption = 1,
    fixedPremium,
    planEstablishProduct,
    optionalRiderList,
    exchangeRate,
    onApplyFixedOption,
    onChangeFixedPremium,
  } = props;

  const inputRef = useRef();
  const [isShowFixedTooltip, setIsShowFixedTooltip] = useState(false);
  const [fixedOptionValidRule, setFixedOptionValidRule] = useState([]);
  const [fixedOptionValidMsg, setFixedOptionValidMsg] = useState([]);

  useEffect(() => {
    const { faceAmount, premium } = planEstablishProduct.find(
      product => product.mainPolicyRiderTypeCode === 'P',
    );
    if (toFloatNumber(premium) > 0) {
      const minValue =
        Math.ceil(
          Math.round(
            planEstablishProduct
              .map(product => toFloatNumber(product.premium))
              .reduce((a, b) => a + b) * exchangeRate,
          ) / 1000,
        ) * 1000;

      const maxValue =
        Math.floor(
          Math.round(toFloatNumber(premium) * 1.5 * exchangeRate) / 1000,
        ) * 1000;

      if (minValue < maxValue) {
        const validMsg = `${toCurrency(minValue)} ~ ${toCurrency(
          maxValue,
        )} / ${UNIT} 단위로 입력하세요.`;
        const validRule = [
          {
            rule: v =>
              parseInt(toNumber(v)) >= parseInt(minValue) &&
              parseInt(toNumber(v)) <= parseInt(maxValue) &&
              parseInt(toNumber(v)) % parseInt(toNumber(UNIT)) === 0,
            errMsg: validMsg,
          },
        ];

        setFixedOptionValidMsg(validMsg);
        setFixedOptionValidRule(validRule);
      } else {
        onApplyFixedOption(false);
      }
    } else {
      if (toFloatNumber(faceAmount) === 0 && fixedOption === 0) {
        onApplyFixedOption(false);
      }
    }
  }, [planEstablishProduct]);

  useEffect(() => {
    if (parseInt(fixedPremium) !== 0 && fixedOptionValidRule.length > 0) {
      onChangeFixedPremium(fixedPremium, inputRef.current.isValidCheck());
    }
  }, [fixedOptionValidRule, fixedPremium]);

  useEffect(() => {
    if (
      fixedOption === 0 &&
      !optionalRiderList.find(
        optionalRider => optionalRider.code === 'Z31600100', // 달러유니버셜특약
      )
    ) {
      onApplyFixedOption(false);
    }
  }, [optionalRiderList]);

  const handleFixedPremium = (value, valid) => {
    onChangeFixedPremium(value, !valid.visible);
  };

  return (
    <React.Fragment>
      <div className="tit-area">
        <h2>원화고정납입옵션</h2>
      </div>
      <div className="list-sp">
        <SatCheckBox
          value={[Number(fixedOption) === 0]}
          options={[{ label: '신청', value: false }]}
          disabled={
            !optionalRiderList.find(
              optionRider => optionRider.code === 'Z31600100', // 달러유니버셜특약
            )
          }
          onChange={onApplyFixedOption}
        />
        <div className="box-item-tootip">
          <span className="txt">고정납입보험료</span>
          <SatToolTip
            show={isShowFixedTooltip}
            setShow={flag => setIsShowFixedTooltip(flag ? true : false)}
            toolTips={[
              {
                title: '고정납입보험료',
                message: () => (
                  <p>
                    원화환산보험료(특약보험료 제외)의 <br />
                    100%~150% 중 선택
                  </p>
                ),
              },
            ]}
          />
        </div>
        <div className="fix-pay">
          <div className="amount">
            <SatInput
              ref={inputRef}
              type={'currency'}
              value={fixedPremium}
              readOnly={
                fixedOption === 1 ||
                parseInt(
                  planEstablishProduct.find(
                    product => product.mainPolicyRiderTypeCode === 'P',
                  ).premium,
                ) === 0
              }
              onChange={handleFixedPremium}
              outerSuffix={() => <span className="txt">원</span>}
              validRule={fixedOptionValidRule}
              validGuide={{ fixed: false, guideMsg: fixedOptionValidMsg }}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(KrwFixedOption);
